export default function createUrl (url = window.location.href) {
  const regex = /^((?:http[s]?:)\/\/)?([^:/]+)([^\w\-..]+[^?#]+)(\?[^#]+)?(#.*)?/i;
  const [, scheme = '', host, path = '', query = '?', fragment = ''] = regex.exec(url);
  const queryParams = query
    .substr(1)
    .split('&')
    .map(segment => segment.split('='))
    .filter(([segment]) => segment)
    .reduce((params, [key, value = '']) => ({ ...params, [key]: value }), {});

  return {
    fragment,
    host,
    path,
    scheme,
    queryParams,

    get queryString () {
      const result = Object.keys(this.queryParams)
        .map(key => `${key}=${this.queryParams[key]}`)
        .join('&');

      return result ? `?${result}` : '';
    },

    get href () {
      return `${this.scheme}${this.host}${this.path}${this.queryString}${this.fragment}`;
    },

    setQueryParam (key, value) {
      this.queryParams[key] = value;
      return this;
    },

    removeQueryParams (...keys) {
      keys.forEach(key => delete queryParams[key]);
      return this;
    },
  };
}

/**
 * Builds a URL with protocol and source URL following the project pattern
 * 
 * @param {Object} params
 * @param {string} params.sourceUrl - Source URL from config (e.g., 'www.reservamos.mx/api/v2')
 * @param {string} params.path - Path to append to sourceUrl (e.g., '/calendar')
 * @param {boolean} params.forceHttps - Force HTTPS protocol (optional, from config)
 * @returns {Object} URL object from createUrl utility
 */
export const buildApiUrl = ({ sourceUrl, path = '', forceHttps = false }) => {
  const protocol = window.location.protocol.includes('https') || forceHttps ? 'https:' : 'http:';
  const fullPath = path ? `${sourceUrl}${path}` : sourceUrl;
  return createUrl(`${protocol}//${fullPath}`);
};
